import { useTranslate } from "@tolgee/react";
import { LocalizedLink } from "#/components/locale/localized-link";

export function NotFound() {
	const { t } = useTranslate();
	return (
		<div className="flex min-h-[calc(100dvh-48px)] flex-col items-center justify-center px-4">
			<p className="text-display3 text-primary/20 sm:text-display1">
				404
			</p>
			<h1 className="mt-2 text-title1 text-foreground sm:text-title1">
				{t("not-found.title")}
			</h1>
			<p className="mt-2 text-body2 text-muted-foreground">
				{t("not-found.description")}
			</p>
			<LocalizedLink
				to="/"
				className="mt-8 inline-flex h-10 items-center rounded-md bg-primary px-5 text-body2-medium text-primary-foreground transition-colors hover:bg-primary/90"
			>
				{t("actions.back-to-home")}
			</LocalizedLink>
		</div>
	);
}
